var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c("el-form", {
    attrs: {
      inline: true
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "邮件状态：",
      "label-width": "90px"
    }
  }, [_c("el-select", {
    staticStyle: {
      width: "150px"
    },
    attrs: {
      placeholder: "请选择"
    },
    model: {
      value: _vm.email_state,
      callback: function callback($$v) {
        _vm.email_state = $$v;
      },
      expression: "email_state"
    }
  }, _vm._l(_vm.options, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.label,
        value: item.id
      }
    });
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "日期：",
      "label-width": "70px"
    }
  }, [[_c("data-options", {
    attrs: {
      clearable: false
    },
    model: {
      value: _vm.formTime,
      callback: function callback($$v) {
        _vm.formTime = $$v;
      },
      expression: "formTime"
    }
  })]], 2), _c("el-form-item", [[_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.queryEvent();
      }
    }
  }, [_vm._v("查询")])]], 2), _vm.isShowBatch ? _c("el-form-item", [[_c("el-button", {
    attrs: {
      type: "success"
    },
    on: {
      click: function click($event) {
        return _vm.approvalBtn();
      }
    }
  }, [_vm._v("批量审批")])]], 2) : _vm._e()], 1)], 1), [_c("el-table", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.tableData,
      border: "",
      "row-key": "authorityId",
      stripe: ""
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_vm.isShowBatch ? _c("el-table-column", {
    attrs: {
      type: "selection",
      width: "55"
    }
  }) : _vm._e(), _c("el-table-column", {
    attrs: {
      label: "邮件ID",
      "min-width": "60",
      prop: "email_id"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "邮件类型",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("div", {
          class: [scope.row.email_type == "2" ? "serClass" : "perClass"],
          attrs: {
            slot: "reference"
          },
          slot: "reference"
        }, [_vm._v(" " + _vm._s(scope.row.email_type == "2" ? "单服邮件" : "个人邮件") + " ")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "邮件状态",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("div", {
          class: [_vm.classStatus[scope.row.email_state]],
          attrs: {
            slot: "reference"
          },
          slot: "reference"
        }, [_c("el-tag", {
          attrs: {
            size: "medium"
          }
        }, [_vm._v(" " + _vm._s(_vm.emailStatus[scope.row.email_state]) + " ")])], 1)];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "邮件标题",
      "min-width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(scope.row.email_ext.email_title) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "邮件内容",
      "min-width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(scope.row.email_ext.email_content) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "邮件接收",
      "min-width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.email_ext.condition != null ? _c("div", [_c("el-tag", {
          attrs: {
            size: "medium"
          }
        }, [_vm._v("条件")])], 1) : _vm._e(), _c("el-tooltip", {
          attrs: {
            content: scope.row.content,
            placement: "top"
          },
          scopedSlots: _vm._u([{
            key: "content",
            fn: function fn() {
              return [_vm._l(scope.row.email_ext.role_info_arr, function (row, k) {
                return _c("div", {
                  key: k
                }, [_c("span", [_vm._v(_vm._s(row.roleId) + " " + _vm._s(row.roleName))])]);
              }), _vm._l(scope.row.email_ext.server_id_list, function (row, k) {
                return _c("div", {
                  key: k
                }, [_c("span", [_vm._v(_vm._s(_vm.showMore[scope.row.email_id]) + _vm._s(scope.row.email_id) + _vm._s(_vm.serverList[row]))])]);
              })];
            },
            proxy: true
          }], null, true)
        }, [_c("div", [_vm._l(scope.row.email_ext.role_info_arr, function (row, k) {
          return _c("div", {
            key: k
          }, [_c("span", {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: k <= 2 || _vm.showMore[scope.row.email_id],
              expression: "k<=2 || showMore[scope.row.email_id]"
            }]
          }, [_vm._v(_vm._s(row.roleId) + " " + _vm._s(row.roleName))])]);
        }), _vm._l(scope.row.email_ext.server_id_list, function (row, k) {
          return _c("div", {
            key: k
          }, [_c("span", {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: k <= 2 || _vm.showMore[scope.row.email_id],
              expression: "k<=2 || showMore[scope.row.email_id]"
            }]
          }, [_vm._v(_vm._s(_vm.showMore[scope.row.email_id]) + _vm._s(scope.row.email_id) + _vm._s(_vm.serverList[row]))])]);
        }), _c("div", {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: scope.row.email_ext.server_id_list && scope.row.email_ext.server_id_list.length > 3 || scope.row.email_ext.role_info_arr && scope.row.email_ext.role_info_arr.length > 3,
            expression: "(scope.row.email_ext.server_id_list && scope.row.email_ext.server_id_list.length>3) || (scope.row.email_ext.role_info_arr && scope.row.email_ext.role_info_arr.length>3)"
          }]
        }, [_c("span", {
          staticStyle: {
            color: "blue",
            cursor: "pointer"
          },
          on: {
            click: function click($event) {
              return _vm.showItemMore(scope.row.email_id);
            }
          }
        }, [_vm._v("查看更多")])])], 2)])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "邮件物品",
      "min-width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return _vm._l(scope.row.email_ext.item_list, function (row, k) {
          return _c("div", {
            key: k
          }, [row.item_id ? [_vm._v(" " + _vm._s(_vm.goodList[row.item_id]) + " "), _c("span", {
            staticStyle: {
              color: "red"
            }
          }, [_vm._v("*" + _vm._s(row.num))])] : _vm._e()], 2);
        });
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      fixed: "right",
      label: "操作",
      width: "460"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-button", {
          attrs: {
            size: "small",
            type: "primary"
          },
          on: {
            click: function click($event) {
              return _vm.checkEmail(scope.row);
            }
          }
        }, [_vm._v("查看邮件")]), _c("el-button", {
          attrs: {
            disabled: scope.row.email_state === 1 ? false : true,
            icon: "el-icon-edit",
            size: "small",
            type: "primary"
          },
          on: {
            click: function click($event) {
              return _vm.handleEdit(scope.row);
            }
          }
        }, [_vm._v("审批")]), scope.row.email_state !== 5 ? _c("el-button", {
          attrs: {
            disabled: scope.row.email_state !== 1 ? false : true,
            icon: "el-icon-edit",
            size: "small",
            type: "primary"
          },
          on: {
            click: function click($event) {
              return _vm.handleCheckReason(scope.row);
            }
          }
        }, [_vm._v("查看审核原因 ")]) : _vm._e(), scope.row.email_state == 5 ? _c("el-button", {
          attrs: {
            size: "small",
            type: "primary"
          },
          on: {
            click: function click($event) {
              return _vm.resendBtn(scope.row);
            }
          }
        }, [_vm._v(" 重新发送 ")]) : _vm._e()];
      }
    }])
  })], 1)], _c("el-pagination", {
    style: {
      float: "right",
      padding: "20px"
    },
    attrs: {
      "current-page": _vm.page,
      "page-size": _vm.pageSize,
      "page-sizes": [5, 30, 50, 100, 500],
      total: _vm.total,
      layout: "total, sizes, prev, pager, next, jumper"
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  }), _c("div", [_vm.if_centerDialogVisible ? _c("el-dialog", {
    attrs: {
      title: _vm.nowEmailState === 1 ? "请填写审批原因" : "查看审批原因",
      visible: _vm.centerDialogVisible,
      width: "50%",
      center: ""
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.centerDialogVisible = $event;
      }
    }
  }, [_c("div", {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c("el-radio", {
    attrs: {
      disabled: _vm.nowEmailState === 1 ? false : true,
      label: "1"
    },
    model: {
      value: _vm.radio,
      callback: function callback($$v) {
        _vm.radio = $$v;
      },
      expression: "radio"
    }
  }, [_vm._v("此邮件通过")]), _c("el-radio", {
    attrs: {
      disabled: _vm.auditType === 1 ? false : true,
      label: "2"
    },
    model: {
      value: _vm.radio,
      callback: function callback($$v) {
        _vm.radio = $$v;
      },
      expression: "radio"
    }
  }, [_vm._v("此邮件驳回")])], 1), _c("div", {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c("el-input", {
    attrs: {
      type: "textarea",
      disabled: _vm.auditType === 1 ? false : true,
      autosize: {
        minRows: 3,
        maxRows: 5
      },
      placeholder: "请输入内容"
    },
    model: {
      value: _vm.showReason,
      callback: function callback($$v) {
        _vm.showReason = $$v;
      },
      expression: "showReason"
    }
  })], 1), _c("span", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    on: {
      click: function click($event) {
        _vm.centerDialogVisible = false;
      }
    }
  }, [_vm._v("取 消")]), _vm.isRadioType == 1 ? _c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.keepBtn("1");
      }
    }
  }, [_vm._v("确 定")]) : _c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.keepBtn("2");
      }
    }
  }, [_vm._v("确 定")])], 1)]) : _vm._e()], 1), _c("div", [_vm.if_dialogFormVisible ? _c("el-dialog", {
    attrs: {
      title: "查看详细邮件信息",
      visible: _vm.dialogFormVisible,
      center: ""
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.dialogFormVisible = $event;
      }
    }
  }, [_c("show-email-msg", {
    staticStyle: {
      height: "500px",
      "overflow-y": "auto"
    },
    attrs: {
      formData: _vm.formData,
      openEmailType: _vm.openEmailType
    }
  })], 1) : _vm._e()], 1)], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };